{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Shabllonet",
    "DESCRIPTION": "Shiko shabllonet e mesazheve të sinkronizuara nga kutitë tuaja hyrëse të WhatsApp. Për të krijuar ose redaktuar një shabllon, menaxhoje atë te ofruesi juaj.",
    "COUNT": "{n} shabllon | {n} shabllone",
    "LEARN_MORE": "Mëso më shumë rreth shablloneve të WhatsApp",
    "SYNC_TEMPLATES": "Sinkronizo shabllonet",
    "SYNC_SUCCESS": "Sinkronizimi i shablloneve filloi për të gjitha kutitë hyrëse të WhatsApp. Përditësimet mund të marrin pak minuta.",
    "PARTIAL_SYNC_ERROR": "Sinkronizimi i shablloneve filloi për disa kuti hyrëse të WhatsApp, por të tjerat nuk u sinkronizuan dot.",
    "SYNC_ERROR": "Nuk u arrit të fillohej sinkronizimi i shablloneve. Provoni përsëri.",
    "SEARCH_PLACEHOLDER": "Kërko sipas përmbajtjes ose emrit...",
    "MANAGE_IN_META": "Menaxho në Meta",
    "LOADING": "Po ngarkohen shabllonet e WhatsApp...",
    "EMPTY": "Nuk u gjet asnjë shabllon WhatsApp.",
    "NO_RESULTS": "Asnjë shabllon nuk përputhet me filtrat tuaj.",
    "FETCH_ERROR": "Nuk u arritën të ngarkoheshin shabllonet e WhatsApp. Provoni përsëri.",
    "PARTIAL_FETCH_ERROR": "Disa shabllone të WhatsApp nuk u ngarkuan dot. Provoni përsëri.",
    "LAST_SYNC_ATTEMPT": "Përpjekja e fundit e sinkronizimit më {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Nuk është dërguar për miratim nga WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Të gjitha kutitë hyrëse",
      "ALL_LANGUAGES": "Të gjitha gjuhët",
      "ALL_TYPES": "Të gjitha llojet"
    },
    "TYPES": {
      "TEXT": "Tekst",
      "IMAGE": "Imazh",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Thirrje për veprim",
      "COPY_CODE": "Kopjo kodin"
    },
    "PREVIEW": {
      "TITLE": "Pamja paraprake e shabllonit",
      "DESCRIPTION": "Shiko paraprakisht si duket ky shabllon në WhatsApp.",
      "OPEN": "Shiko paraprakisht {name}",
      "CLOSE": "Mbyll pamjen paraprake",
      "DETAILS": "Detajet e shabllonit",
      "STATUS": "Statusi",
      "TYPE": "Lloji i përmbajtjes",
      "CATEGORY": "Kategoria",
      "LANGUAGE": "Gjuha",
      "INBOXES": "Kutitë hyrëse"
    }
  }
}
